export default __webpack_public_path__ + "661dc0fa478754373d14f216441a6e97.png";